import { useState } from 'react';
import { Button, Icon } from './slate-component';
import { useSlateStatic, ReactEditor } from 'slate-react';
import { insertImage } from '../utils/Image';
import UploadFileDialog from '../../uploadFileDialog';

export default function InsertImageButton() {
  const editor = useSlateStatic();
  const [visible, setVisible] = useState(false);

  const handleSuccess = (file) => {
    setVisible(false);
    // console.log(file);
    insertImage(editor, file.response);
  };
  return (
    <>
      <Button
        onMouseDown={(event) => {
          event.preventDefault();
          setVisible(true);
          // if (url && !isImageUrl(url)) {
          //   alert('URL is not an image');
          //   return;
          // }
          // insertImage(editor, url);
        }}>
        <Icon>image</Icon>
      </Button>
      <UploadFileDialog
        visible={visible}
        onSuccess={handleSuccess}
        onError={(err) => console.log(err)}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
}
